var map = {
	"./en_US/iap.json": 8599,
	"./en_US/iapfe.json": 622,
	"./in_ID/iapfe.json": 8155,
	"./ru_RU/iap.json": 6380,
	"./ru_RU/iapfe.json": 1885
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4824;